
export class JanglInputController {
    $onInit() {
        this.type = this.type || 'text';
        this._errorMessages = angular.copy(this.errorMessages) || [];

        if (!this._errorMessages.find((item) => { return (item.type == 'required')})) {
            this._errorMessages.push({type: 'required', msg: this.label + ' is required.'});
        }
    }
}
JanglInputController.$inject = [];

export default JanglInputController;


// WEBPACK FOOTER //
// ./app/jangl/jangl-input/controller.js